"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInTheFuture = exports.getTodaysDateFormatted = exports.default = void 0;
var getDateDisplayValue = function getDateDisplayValue(date) {
  return new Date(date).toISOString().split('T')[0];
};
var getTodaysDateFormatted = function getTodaysDateFormatted() {
  return getDateDisplayValue(Date.now());
};
exports.getTodaysDateFormatted = getTodaysDateFormatted;
var isInTheFuture = function isInTheFuture(date) {
  var d = new Date(getDateDisplayValue(date)).getTime();
  return d > Date.now();
};
exports.isInTheFuture = isInTheFuture;
var _default = getDateDisplayValue;
exports.default = _default;